<template>
  <div class="modal" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
       role="dialog"
       style="display:block; background-color:rgba(255, 255, 255, 0.6);">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">사업자 검색</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">
          <!-- 조회 영역 -->
          <div class="seaerch-box d-flex flex-column">
            <div>
              <span class="input-label m-2">사업자 유형</span>
              <kona-select class="form-select m-2" :options="typeOptions" @change="onChange($event)"></kona-select>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-inline-flex">
                <span class="input-label m-2">사업자명</span>
                <kona-input class="form-control w-150" v-model="name"></kona-input>
              </div>
              <button type="button" class="search-btn w-20 h-100" @click="getCompanyList()">
                <Search/> &nbsp; {{ regions.button.search }}
              </button>
            </div>
          </div>
          <div class="row">
            <!-- 조회 결과 테이블 -->
            <div class="pagenation">
              <div class="menu-permission-list scroll-box">
                <table class="permission-list-table">
                  <thead>
                  <tr>
                    <th>No.</th>
                    <th>
                    </th>
                    <th>{{ regions.permission.companyName }}</th>
                    <th>{{ regions.permission.companyNumber }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(company, i) in searchedItems" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <input
                          type="checkbox"
                          class="form-check-input"
                          :value="company.isChecked"
                          v-model="company.isChecked"
                          :disabled="company.isDisabled"
                          @change="changeSubMenuCheck(searchedItems, company.isChecked)"
                      />
                    </td>
                    <td>{{ company.name }}</td>
                    <td>{{ company.officeId }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <paginate
                  v-show="pageInfo.totalElements"
                  class="justify-content-lg-center mt-3"
                  :page-count="pageInfo.totalPages"
                  :force-page="pageInfo.currentPage"
                  :first-last-button="true"
                  first-button-text="<<"
                  last-button-text=">>"
                  prev-text="<"
                  next-text=">"
                  :hide-prev-next="true"
                  :click-handler="pageHandler">
              </paginate>
            </div>
          </div>
          <!-- 수정/저장 버튼 -->
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-success" @click="clickSaveBtn">
              추가
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useStore} from 'vuex';
import axios from "@/composables/Axios";
import {BIconSearch as Search} from "bootstrap-icons-vue";
import {convertType} from "@/components/operation/common/CommonFunction"
import Paginate from "vuejs-paginate-next";
import Entity from '@/entity/OperationEntity'

const emit = defineEmits(['close', 'selectPartner']);
const store = useStore(),
    url = store.state['api'].operationUrl,
    regions = store.state.region['regions'];

const searchedItems = ref([]);
let selectPartner = null;
const typeOptions = ref(["전체", "법인", "개인"]);
const selectedType = ref("전체")

const pageInfo = ref({
  totalElements: 0,
  totalPages: 1,
  currentPage: 1
});

const name = ref('');

onMounted(() => getCompanyList());

// 개별 체크
const changeSubMenuCheck = (subCheck, checkValue) => {
  if (checkValue) { // 체크
    subCheck.forEach(element => {
      if (element.isChecked) {
        selectPartner = element;
      } else {
        element.isDisabled = true;
      }
    });
  } else { // 체크 해제
    subCheck.forEach(element => {
      element.isDisabled = false;
    });
    selectPartner = null;
  }
}

// 전체 운수사 리스트 가져오기 
const getCompanyList = async (page = 1, size = 10) => {
  const entity = new Entity.organizationHeaders(store.state.sign['userInfo'].userId);
  const headers = entity.get();
  const queryParams = {
    params: {
      partnerType: convertType(selectedType.value),
      page: page - 1,
      size: size,
      name: name.value
    }
  }

  try {
    const res = await axios.$get(`${url}partner/auth/partner`, queryParams, headers);
    searchedItems.value = res.data.data.content.map(v => ({...v, isChecked: false, isDisabled: false}));
    pageInfo.value.totalPages = res.data.data.totalPages;
    pageInfo.value.totalElements = res.data.data.totalElements;
    pageInfo.value.currentPage = page;
  } catch (err) {
    store.commit("openMessageBox", err);
  }
}

const clickSaveBtn = () => {
  if (selectPartner === null) {
    store.commit("운수사를 선택해주세요.");
    return;
  }

  emit('selectPartner', selectPartner);
  emit('close');
}

const onChange = (e) => selectedType.value = e.target.value;

const pageHandler = (pageNum) => {
  getCompanyList(pageNum);
}

</script>

<style scoped>
button {
  border: none;
  padding: 0.25rem 2rem;
  font-size: 13px;
  color: #ffffff;
  display: flex;
  align-items: center;
  border-radius: 2px;
}

.modal-content {
  border-radius: 4px;
  width: auto;
  position: absolute;
  top: 0;
  right: 0;
}

.modal-dialog {
  font-size: 0.8rem;
  max-width: 70rem;
  min-width: 60rem;
}

.row {
  flex-wrap: nowrap;
  justify-content: space-between;
  margin: 1rem;
  padding: 0;
}

.row > * {
  width: unset;
}


th {
  position: sticky;
  top: 0;
  background-color: white;
}

.form-select {
  width: 7rem;
}

.search-btn {
  background-color: #000000;
}

.input-label {
  font-weight: bold;
  margin: auto;
  width: 4rem;
  font-size: 0.8rem;
}

.form-select {
  display: inline;
  padding: 0 0.5rem;
  font-size: 0.8rem;
  border-radius: 0;
  width: 6rem;
}

/* 테이블 */
.menu-permission-list {
  overflow: auto;
  height: calc(100% - 17.5rem);
  width: 100%;
  border-bottom: 1px solid #ced4da;
}

.permission-list-table {
  width: 100%;
  /* height: 100%; */
}

.permission-list-table th {
  border-bottom: 1px solid #c9c8c8;
  padding: 8px;
  max-height: 36px;
}

.permission-list-table td {
  border-bottom: 1px solid #c9c8c8;
  padding: 8px;
}

.permission-list-table thead {
  position: sticky;
  top: 0;
  text-align: center;
  z-index: 2;
}

.scroll-box {
  width: 26rem;
  height: 25rem;
  overflow: auto;
  /* border: 1px solid #ced4da; */
}

table tbody td {
  text-align: center;
}

.form-control {
  width: auto;
  height: 30px;
}
</style>